import "./Profile.css";
import React, { useEffect, useState } from 'react';
import { useContext } from 'react';
import { Context } from "../../components/Context/AuthContext";
import { ref, onValue, update, remove } from 'firebase/database';
import { db } from "../../index";
import InputMask from 'react-input-mask';
import { useNavigate } from "react-router-dom";
import { deleteUser, getAuth } from "firebase/auth";

export function Profile() {
  const { user } = useContext(Context);
  const [email, setEmail] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [role, setRole] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const userID = user?.uid;
    if (userID) {
      const userRef = ref(db, `users/${userID}`);
      onValue(userRef, (snapshot) => {
        const data = snapshot.val();
        setEmail(data?.email || '');
        setDisplayName(data?.displayName || '');
        setPhoneNumber(data?.phoneNumber || '');
        setRole(data?.role || '');
      });
    }
  }, [user]);

  const handleUpdate = async (e) => {
    e.preventDefault();
    const userID = user?.uid;
    if (userID) {
      const userRef = ref(db, `users/${userID}`);
      await update(userRef, {
        displayName,
        phoneNumber,
      });
      alert('Информация обновлена успешно!');
    }
  };

  const handleDeleteAccount = () => {
    if (window.confirm("Вы уверены, что хотите удалить аккаунт?")) {
      const auth = getAuth();
      const user = auth.currentUser;
      const userId = user.uid;
  
      deleteUser(user)
        .then(() => {
          console.log("Аккаунт удален из Authentication");
          remove(ref(db, `users/${userId}`))
            .then(() => {
              console.log("Данные пользователя удалены из Realtime Database");
            })
            .catch((error) => {
              console.error("Ошибка удаления данных пользователя из Realtime Database:", error);
            });
        })
        .catch((error) => {
          console.error("Ошибка удаления аккаунта из Authentication:", error);
        });
  
      alert("Аккаунт удален");
      navigate("/signin");
    }
  };

  return (
    <div className="aside-right__desc center">
      <div className="modal profile-modal">
        <h2>Профиль</h2>
        {user ? (
          <form onSubmit={handleUpdate}>
            <div className="modal__item">
              <label>
                Почта:
                <input
                  className="readOnly"
                  type="text"
                  value={email || ''}
                  onChange={(e) => setEmail(e.target.value)}
                  readOnly
                />
              </label>
            </div>
            <div className="modal__item">
              <label>
                Имя:
                <input
                  type="text"
                  value={displayName}
                  onChange={(e) => setDisplayName(e.target.value)}
                />
              </label>
            </div>
            <div className="modal__item">
              <label>
                Телефон:
                <InputMask
                  type="tel"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  mask="+7(999) 999-99-99"
                  placeholder="Телефон"
                />
              </label>
            </div>
            <div className="modal__item">
              <label>
                Роль:
                <input
                  className="readOnly"
                  type="text"
                  value={role}
                  onChange={(e) => setRole(e.target.value)}
                  readOnly
                />
              </label>
            </div>
            <div className="modal__item justify-center flex padding margin">
              <button className="modal__button btn-item" type="submit">Обновить</button>
            </div>
            <div className="modal__item justify-center flex padding margin">
              <button className="modal__button btn-item_delete" onClick={handleDeleteAccount}>Удалить аккаунт</button>
            </div>
          </form>
        ) : (
          <>Пользователь не авторизован</>
        )}
      </div>
    </div>
  );
}